import { Component, inject } from '@angular/core';
import {SharedModalControllerService} from '@shared/services/shared-modal-controller.service';
import {IonicModule, ModalController} from "@ionic/angular";
import {TranslatePipe} from "@ngx-translate/core";



@Component({
  selector: 'app-shared-confirm-leave-modal',
  templateUrl: './shared-confirm-leave-modal.component.html',
  styleUrls: ['./shared-confirm-leave-modal.component.scss'],
  imports: [
    IonicModule,
    TranslatePipe
    ],
  standalone: true,
})
export class SharedConfirmLeaveModalComponent {
  private _modalController = inject(ModalController);
  private _sharedModalControllerService = inject(SharedModalControllerService);


  answer(response: boolean) {
    void this._modalController.dismiss({ confirmed: response });
  }

  exit(): void {
    this._sharedModalControllerService.closeModal();
  }
}
